import React from "react";
// ? Redux
import { useDispatch } from "react-redux";
import { loadDetail } from "../actions/gameDetailAction";
// ? Style
import styled from "styled-components";
import { motion } from "framer-motion";
// ? Router
import { Link } from "react-router-dom";
// ? Utils
import { smallImage } from "../util";

const Game = ({ game }) => {
  // ? Load Details
  const dispatch = useDispatch();
  const loadDetailHandler = (id) => {
    dispatch(loadDetail(id));
  };
  return (
    <Link to={`/games/${game.slug}`}>
      <StyledGame onClick={() => loadDetailHandler(game.id)}>
        <h3>{game.name}</h3>
        <p>{game.released}</p>
        {game.background_image && (
          <img
            src={smallImage(game.background_image, 640)}
            loading="lazy"
            alt={game.name}
          />
        )}
      </StyledGame>
    </Link>
  );
};

// ? Style
const StyledGame = styled(motion.div)`
  background-color: rgba(54, 54, 54, 1);
  min-height: 30vh;
  box-shadow: 0px 5px 20px #2a2a2a;
  text-align: center;
  border-radius: 1rem;
  overflow: hidden;
  img {
    width: 100%;
    height: 40vh;
    object-fit: cover;
  }
`;

export default Game;
